import { FC, useState } from 'react'

import { FieldProps as FormikFieldProps } from 'formik'
import { useIntl } from 'react-intl'
import { AnyObjectSchema } from 'yup'

import { IconButton, TextField, TextFieldProps } from '@themenu/design-system'

import { isRequiredField } from '../../utils/isRequiredField'

export type FormikFieldInputPasswordProps = TextFieldProps & FormikFieldProps & { validationSchema?: AnyObjectSchema }

export const FormikFieldInputPassword: FC<FormikFieldInputPasswordProps> = ({
  form,
  field,
  validationSchema,
  ...props
}) => {
  const isRequired = validationSchema ? isRequiredField({ validationSchema, fieldName: field.name }) : props.required
  const [passwordShown, setPasswordShown] = useState(false)

  const showPassword = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault()
    setPasswordShown(!passwordShown)
  }

  const intl = useIntl()
  return (
    <TextField
      size={56}
      required={isRequired}
      error={form?.touched[field.name] !== undefined && form?.errors[field.name] !== undefined}
      errorMessage={(form?.errors[field.name] as string) || ''}
      {...field}
      {...props}
      id={field.name}
      type={passwordShown ? 'text' : 'password'}
      suffix={
        <IconButton
          name={passwordShown ? 'eye-close' : 'eye-open'}
          variant="text"
          size={20}
          onClick={showPassword}
          aria-label={intl.formatMessage({ id: 'sign_in.form.password.icon' })}
          tabIndex={-1}
        />
      }
    />
  )
}
